import { usePncpBiddingDetailDispatch } from './pncp-bidding-detail-context';
import PortalAppService from '../../../application/platform/portal-app-service';

export const PNCP_ITEMS_PAGE_SIZE = 20;

export function usePncpBiddingDetailController() {
  const dispatch = usePncpBiddingDetailDispatch();

  const loadDetail = async (id: number) => {
    dispatch({ type: 'LOAD_START' });

    try {
      const response = await PortalAppService.getPncpBiddingDetail(id);
      dispatch({ type: 'LOAD_SUCCESS', payload: response });
    } catch (error: any) {
      const errorMessage = error?.response?.data?.message || 'Erro ao carregar detalhes da licitação';
      dispatch({ type: 'LOAD_ERROR', payload: errorMessage });
    }
  };

  // As páginas de itens do PNCP começam em 1 e não trazem o total: há mais enquanto a página vem cheia
  const loadItems = async (id: number, page: number) => {
    dispatch({ type: 'LOAD_ITEMS_START' });

    try {
      const response = await PortalAppService.listPncpBiddingItems(id, { page, pageSize: PNCP_ITEMS_PAGE_SIZE });
      const items = response.items ?? [];
      dispatch({ type: 'LOAD_ITEMS_SUCCESS', payload: { items, page, hasMore: items.length === PNCP_ITEMS_PAGE_SIZE } });
    } catch (error: any) {
      const errorMessage = error?.response?.data?.message || 'Erro ao carregar os itens da licitação';
      dispatch({ type: 'LOAD_ITEMS_ERROR', payload: errorMessage });
    }
  };

  return {
    loadDetail,
    loadItems,
  };
}
